import { ca } from '@cian/analytics';
import { ETopic } from '@cian/feedback-form-widget';

const topicToLabelMap: Partial<{ [key in ETopic]: string }> = {
  [ETopic.ComplaintFromOwnerProperty]: 'OwnerComplainObject',
  [ETopic.ComplaintFromOwnerPhoto]: 'OwnerComplainPhoto',
  [ETopic.PrMedia]: 'PR',
  [ETopic.Advertising]: 'MediaAds',
  [ETopic.OfferComplaint]: 'Complaint',
  [ETopic.Moderation]: 'Moderation',
};

export function trackFeedbackSend(topic: ETopic | null) {
  const label = topic ? topicToLabelMap[topic] || 'Other' : '';

  ca('eventSite', {
    name: 'oldevent',
    category: 'FeedBackForm',
    action: 'Send',
    label,
  });
}
